import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { compose, fixture } from './composition.ts';
import { App } from './ui/app.tsx';
const {
  app,
  home,
  training,
  nutrition,
  progress,
  backup,
  restore,
  restoreRecovery,
} = await compose();

createRoot(
  document.getElementById('root')!,
).render(
  <StrictMode>
    <App
      app={app}
      home={home}
      training={training}
      nutrition={nutrition}
      progress={progress}
      backup={backup}
      restore={restore}
      restoreRecovery={restoreRecovery}
      checkId={fixture.checkId}
    />
  </StrictMode>,
);
if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(() => {
  const status = document.createElement('p'); status.setAttribute('role', 'status');
  status.textContent = 'No se pudo preparar la reapertura sin red. Los datos locales siguen disponibles.';
  document.querySelector('main')?.append(status);
});
